module.exports = __webpack_public_path__ + "img/1 (137).50a4905e.png";